// src/oura/components/plan/planDates.ts
//
// The plan's dates: today, and the last day of a month of the term, counted
// with the same addMonths monthOf uses, so "Ended Thu 17 Sep" and "Month 2
// of 12" can never disagree about where a month ends.

import { dayDate } from "../../lib/oura";
import { addMonths } from "@service/aeo/clientReview";

function isoDay(d: Date): string {
    const p = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** Today, local, as YYYY-MM-DD. */
export function todayIso(): string {
    return isoDay(new Date());
}

/**
 * The last day of month `k` of the term: the k-th anniversary of the start,
 * less one day. "Thu 17 Sep" for month 1 of a term that started on 18 Aug.
 * Null with no usable start.
 */
export function monthEndDay(start: string | null | undefined, k: number): string | null {
    const s = (start ?? "").slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
    const end = addMonths(new Date(`${s}T00:00:00`), k);
    end.setDate(end.getDate() - 1);
    return dayDate(isoDay(end));
}
